import { render, staticRenderFns } from "./SelectTuevsEscala.vue?vue&type=template&id=177c1493&scoped=true&"
import script from "./SelectTuevsEscala.vue?vue&type=script&lang=js&"
export * from "./SelectTuevsEscala.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177c1493",
  null
  
)

export default component.exports